<template>
  <div class="rounded-lg overflow-hidden box-border w-full">
    <div class="scrollable-table-container" :style="tableStyle">
      <table
        class="w-full px-2 relative table-ranking-podium"
        style="border-collapse: separate; border-spacing: 0"
      >
        <thead
          v-if="!isLoading && data.length > 0"
          :style="theadStyle"
          :class="theadClass"
        >
          <tr>
            <th
              v-for="header in filteredHeaders"
              :key="header"
              :class="[
                'p-4 text-xs sm:text-sm md:text-base',
                header === 'Nome' ? 'text-left' : 'text-center',
              ]"
            >
              {{ header }}
            </th>
          </tr>
        </thead>
        <tbody v-if="!isLoading" class="bg-white py-6">
          <tr
            v-for="(row, rowIndex) in data"
            :key="rowIndex"
            class="rounded-lg"
          >
            <td
              v-for="(value, colName) in filteredRow(row)"
              :key="colName"
              :class="[
                'label text-xs sm:text-sm md:text-base',
                colName === 'name' ? 'text-left' : 'text-center ',
              ]"
            >
              <template
                v-if="
                  typeof value === 'number' &&
                  colName !== 'assignments' &&
                  value !== 0
                "
              >
                <a
                  href="#"
                  @click.prevent="openModal(value, colName, row)"
                  :style="{ color: '#114880', fontWeight: 'bold' }"
                >
                  {{ value }}
                </a>
              </template>
              <template v-else>
                {{ value }}
              </template>
            </td>
          </tr>
        </tbody>
        <thead v-else>
          <tr>
            <th
              v-for="index in headers.length"
              :key="index"
              :class="['skeleton-header', 'animate-pulse']"
            ></th>
          </tr>
        </thead>
        <tbody v-if="isLoading" class="bg-white">
          <tr
            v-for="rowIndex in skeletonRows"
            :key="rowIndex"
            class="rounded-lg animate-pulse"
          >
            <td
              v-for="colName in filteredHeaders.length"
              :key="colName"
              :class="['skeleton-cell', 'animate-pulse']"
            ></td>
          </tr>
        </tbody>
      </table>
    </div>
    <ModalRegisterRanking
      :title="popupTitle"
      :isVisible.sync="isModalVisible"
      :pendingProposals="pendingProposals"
      :qtdTotal="qtdTotal"
      :qtdPaginas="qtdPaginas"
      :actualPage="actualPage"
      :consultantName="consultantName"
      @page-changed="pagination"
      @close-modal="closeModal"
    />
  </div>
</template>

<script>
import ModalRegisterRanking from './ModalRegisterRanking.vue';
import service from '../services';
import { STATUS_PROPOSAL } from '../commons/constant/status-proposals-register-ranking';

export default {
  name: 'GenericTable',
  components: {
    ModalRegisterRanking,
  },
  computed: {
    filteredHeaders() {
      return this.headers.filter((header) => header !== 'userId');
    },
    filteredRow() {
      return (row) => {
        const filtered = {};
        for (const key in row) {
          if (key !== 'userId') {
            filtered[key] = row[key];
          }
        }
        return filtered;
      };
    },
  },
  data() {
    return {
      isModalVisible: false,
      popupTitle: '',
      pendingProposals: [],
      qtdTotal: 0,
      qtdPaginas: 0,
      actualPage: 1,
      itemsPerPage: 10,
      status: null,
      userId: null,
      consultantName: '',
    };
  },
  props: {
    headers: {
      type: Array,
      required: true,
    },
    data: {
      type: Array,
      default: () => [],
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
    skeletonRows: {
      type: Number,
      default: 10,
    },
    tableStyle: {
      type: Object,
      default: () => ({}),
    },
    theadStyle: {
      type: Object,
      default: () => ({}),
    },
    theadClass: {
      type: Object,
      default: () => ({}),
    },
    headerClasses: {
      type: String,
      default:
        'p-4 text-xs sm:text-sm md:text-base text-center bg-gray-300 rounded h-8',
    },
    cellClasses: {
      type: String,
      default:
        'px-6 py-4 text-xs sm:text-sm md:text-base text-center bg-gray-200 h-8 rounded',
    },
    startDate: {
      type: String,
      default: '',
    },
    endDate: {
      type: String,
      default: '',
    },
    companyId: {
      type: Number,
      default: 0,
    },
  },
  methods: {
    async openModal(value, title, row) {
      const statusProposta = STATUS_PROPOSAL[title] || 0;

      this.userId = row[Object.keys(row)[7]];
      this.consultantName = row[Object.keys(row)[1]];

      this.pendingProposals = await this.getProposalsForStatus(
        statusProposta,
        this.userId,
      );
      this.popupTitle = title;
      this.isModalVisible = true;

      if (!this.pendingProposals || !this.pendingProposals.length) {
        this.pendingProposals = [];
        this.qtdTotal = 0;
        this.qtdPaginas = 0;
        return;
      }

      this.qtdTotal = this.pendingProposals[0].totalCount;

      this.qtdPaginas = Math.ceil(this.qtdTotal / this.itemsPerPage);
    },

    closeModal() {
      this.isModalVisible = false;
      this.pendingProposals = [];
      this.popupTitle = '';
      this.actualPage = 1;
      this.qtdTotal = 0;
    },

    async getProposalsForStatus(status) {
      try {
        this.$vs.loading();
        if (status) {
          this.status = status;
        }
        const response = await service.post(
          'super-ranking-register',
          'details-proposals',
          {
            startDate: this.startDate,
            endDate: this.endDate,
            companyId: this.companyId,
            status: this.status,
            actualPage: this.actualPage,
            itemsPerPage: this.itemsPerPage,
            userId: this.userId,
          },
        );
        this.$vs.loading.close();
        return response.data;
      } catch (error) {
        this.pendingProposals = [];
        console.error('Failed to fetch proposals:', error);
        this.$vs.loading.close();
        return [];
      }
    },
    async pagination(novaPagina) {
      this.actualPage = novaPagina;
      this.pendingProposals = await this.getProposalsForStatus();
    },
  },
};
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Poppins:wght@500&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;600&display=swap');

.bg-green-success {
  background-color: #e8faf0;
}
.shadow-custom {
  box-shadow: -5px 0 5px 0 rgba(0, 0, 0, 0.05), 5px 0 5px 0 rgba(0, 0, 0, 0.05),
    0 -5px 5px 0 rgba(0, 0, 0, 0.05), 0 5px 5px 0 rgba(0, 0, 0, 0.05);
}
.red-error-10 {
  background-color: #faeaec;
}
.title {
  font-family: 'Poppins', sans-serif;
  font-weight: 500;
  font-style: normal;
  color: #6d6d6d;
  letter-spacing: 0.15px;
  font-size: 0.75rem;
}
.label {
  font-family: 'Inter', sans-serif;
  font-weight: 400;
  line-height: 1rem;
  letter-spacing: 0.25px;
  color: #434343;
}
.text-xxs {
  font-size: 0.625rem;
  line-height: 1rem;
}
.scrollable-tbody {
  padding-top: 50px;
}
.scrollable-table-container {
  display: block;
  max-height: 100%;
  overflow-y: auto;
  scrollbar-color: #114880 transparent;
  scrollbar-width: thin;
}
.scrollable-table-container::-webkit-scrollbar {
  width: 50px;
  height: 50px;
}
.scrollable-table-container::-webkit-scrollbar-track {
  background: transparent;
}
.scrollable-table-container::-webkit-scrollbar-thumb {
  background: #114880;
  border-radius: 8px;
  border: 23px solid transparent;
  background-clip: padding-box;
}
tbody tr:nth-child(even) {
  background-color: #fcf9f9;
}
.table-ranking-podium td,
.table-ranking-podium th {
  padding: 23px 20px;
  border-bottom: 1px solid #e5e7eb;
}
.bg-gray-200 {
  background-color: #e2e8f0;
}
.bg-gray-300 {
  background-color: #cbd5e0;
}
.min-height {
  min-height: 124px;
}
.skeleton-cell {
  background-color: #e2e8f0;
  border-radius: 0;
  height: 20px;
}
.skeleton-header {
  background-color: #cbd5e0;
  border-radius: 0;
  height: 20px;
}
.animate-pulse {
  animation: pulse 1.5s infinite;
}
@keyframes pulse {
  0%,
  100% {
    opacity: 1;
  }
  50% {
    opacity: 0.5;
  }
}
</style>
